export const InitialAuthorizationCodeGrantOutcome = {
    FAILURE: "failure",
    NOT_ATTEMPTED: "not_attempted",
    SUCCESS: "success"
};
